import type { AxiosResponse } from 'axios';

import { baseRoutes, baseRoutesV2, baseUrl } from '@/api/config';

import axiosInstance from '../../instance';
import type { AggrDeviceFieldAggrResponse, AggrDeviceFieldThrResponse } from '../stat/types';
import type { IRequestBodyFilter } from '../static-devices/types';
import type {
  AggrStaticDeviceFieldAggrBody,
  AggrStaticDeviceFieldThrBody,
  AggrStaticPlaysBody,
  AggrStaticPlaysByAdResponse,
  AggrStaticPlaysTotal,
  StaticAdFilters,
} from './types';

export const getStaticAdFilters = (data: IRequestBodyFilter)
  : Promise<AxiosResponse<StaticAdFilters>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: 'stat/aggr/static-ad-filters',
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getDevicesCountByField = (data: AggrStaticDeviceFieldThrBody)
  : Promise<void | AxiosResponse<AggrDeviceFieldThrResponse>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: 'stat/aggr/static-device-field-thr',
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getDeviceStatByAggr = (data: AggrStaticDeviceFieldAggrBody)
  : Promise<void | AxiosResponse<AggrDeviceFieldAggrResponse>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: 'stat/aggr/static-device-field-aggr',
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getPlaysByAd = (data: AggrStaticPlaysBody)
  : Promise<void | AxiosResponse<AggrStaticPlaysByAdResponse>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutesV2}`,
  url: 'stat/aggr/static-plays-by-ad',
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getTotalPlaysByAd = (data: AggrStaticPlaysBody)
  : Promise<void | AxiosResponse<AggrStaticPlaysTotal>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutesV2}`,
  url: 'stat/aggr/static-plays-totals',
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getStaticDeviceByDay = (data: AggrStaticPlaysBody)
  : Promise<void | AxiosResponse<AggrDeviceFieldAggrResponse>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: 'stat/aggr/static-device-by-day',
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getStaticPlaysByDayXlsx = (data: AggrStaticPlaysBody)
  : Promise<void | AxiosResponse<Blob>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: 'stat/aggr/static-plays-by-day-xlsx',
  method: 'POST',
  responseType: 'blob',
  headers: {
    authorization: true,
  },
  data,
});
